import { useContext } from 'react';
import classNames from 'classnames';
import { SaveTemplatePopupContext } from './contextProvider';
import { SAVE_TEMPLATE_PAGE } from './types';
import Create from './Create';
import Popup from '../../sharedComponents/TextEditor/components/Popup';
import Success from './Success';
import ExistingOrNew from './ExistingOrNew';
import LoadingSmall from '../LoadingSmall';
import UpdateExisting from './UpdateExisting';

// REQUIRED: Have to be wrapped in <SaveTemplatePopupProvider>
function SaveTemplatePopup() {
  const { open, setopen, step, loadingTemplates } = useContext(SaveTemplatePopupContext);
  return (
    <Popup height={850} width={600} open={open} setopen={setopen} className="p-6">
      {loadingTemplates && (
        <div>
          <div className={classNames('is-size-5 with-text-color mb-3')}>Save Template</div>
          <div className="is-subtitle mb-6">
            Save this page as a template that you can reuse later.
          </div>
          <LoadingSmall loading={loadingTemplates} />
        </div>
      )}

      {step === SAVE_TEMPLATE_PAGE.EXISTING_OR_NEW && !loadingTemplates && <ExistingOrNew />}
      {step === SAVE_TEMPLATE_PAGE.CREATE && !loadingTemplates && <Create />}
      {step === SAVE_TEMPLATE_PAGE.UDPATE && !loadingTemplates && <UpdateExisting />}
      {step === SAVE_TEMPLATE_PAGE.SUCCESS && !loadingTemplates && <Success />}
    </Popup>
  );
}

export default SaveTemplatePopup;
